module.exports = __webpack_public_path__ + "static/media/unaro.dda186c1.svg";